'use strict';

import {SORT_FIELD_OPTIONS, SORT_ORDER_OPTIONS, REPORT_RANGES} from '../../reviews/ReviewsTabData'
import {STATES} from '../../../common/data/uiData'
import {map} from 'lodash'
import presignedExport from '../../../services/auth/presignedExport';

import qs from 'qs';

export default function (angularModule) {
  angularModule.controller('ReviewsCtrl', function (
    $scope, $uibModal, campaign, user, $state, $location, accountsService, reviewGenService,
    reviewService, updateService, adminSearchService, stringService, reviewDetailModal, locationService,
    reviewResponseTemplateService, configService,
    reviewResponseConfiguration,
    reactContainer
  ) {

    $scope.freshQuery = null;
    $scope.accountSelected = false;
    $scope.campaignId = campaign._id.$oid;

    let states = STATES;

    $scope.state = states.loading;

    $scope.reviewExportConfig = {};

    $scope.noteSettings = {
      usingTable: true,
      colOffset: 1,
      idKey: "reviewId",
      noteType: "review",
      userInfo: user,
      ready: 0
    };

    $scope.hideAdvancedSearch = true;
    $scope.hideTagFilter = true;
    $scope.hideTagConfiguration = true;
    $scope.hideSortFilter = true;
    $scope.displaySortFilterAsText = true;
    $scope.hideMarkNotMine = true;
    $scope.hideReviewTags = true;
    $scope.hideNotes = true;

    $scope.user = user
    $scope.pageStrings = stringService.adminStrings();
    $scope.updateDetails = updateService.getUpdateDetails();
    $scope.reviewIdsToTask = {};

    $scope.accountConfig = {
      required: false,
      accountId: null,
      disableDropdown: false,
    };

    $scope.initialLoad = true;

    $scope.reviewsPaged = {
      reviews: [],
      total: 0,
      pageSize: 15,
      currentPageNum: 1
    };

    $scope.updateConfig = {
      entityId: null,
      pageOneResult: true
    };

    configService.getBrandConfig().then(resp => {
      $scope.brandConfig = resp
    })

    $scope.$watch(() => (locationService.getSelectedGroupId()), (newVal, oldVal) => {
      if (newVal !== oldVal) {
        setGroupId(newVal)
        refreshReviews()
      }
    })

    const setGroupId = (id) => {
      $scope.groupId = id ? id : locationService.getSelectedGroupId()
    }

    $scope.FILTER_OPTIONS = {
      SORT_FIELD: SORT_FIELD_OPTIONS,
      SORT_ORDER: SORT_ORDER_OPTIONS,
      REPORT_RANGES: REPORT_RANGES
    };

    $scope.filterState = {
      advancedSearch: [],
      reportRange: _.find(REPORT_RANGES,{id:"Last3Months"}),
      startDate: null,
      endDate: null,
      sortField: _.find(SORT_FIELD_OPTIONS,{value:"reviewDate"}),
      sortOrder: _.find(SORT_ORDER_OPTIONS,{value:"DESC"})
    }

    let searchParams = {
      campaignId: $scope.campaignId,
      providers: 'REVIEWBUILDER',
      groupId: $scope.groupId,
      sortField: "dateAdded",
      sortOrder: "DESC",
      reportRange: $scope.filterState.reportRange.id,
      limitOpt: $scope.reviewsPaged.pageSize,
      offsetOpt: ($scope.reviewsPaged.currentPageNum - 1) * $scope.reviewsPaged.pageSize,
    }

    $scope.sortReviewsTable = function () {
      // Don't refresh reviews table when selecting selected dates for the first time
      if ($scope.filterState.reportRange.id === 'SpecificDates' &&
        ($scope.filterState.startDate === null ||
        $scope.filterState.endDate === null)) {
        return
      }

      searchParams.sortField = $scope.filterState.sortField.value
      searchParams.sortOrder = $scope.filterState.sortOrder.value
      searchParams.offsetOpt = 0;
      searchParams.reportRange = $scope.filterState.reportRange.id;
      searchParams.startDate = $scope.filterState.reportRange.id === 'SpecificDates' && $scope.filterState.startDate ? $scope.filterState.startDate : null;
      searchParams.endDate = $scope.filterState.reportRange.id === 'SpecificDates' && $scope.filterState.endDate ? $scope.filterState.endDate : null;

      $scope.loadingReviewDetails = true;

      refreshReviews()
    };

    $scope.$watch("filterState.startDate", $scope.sortReviewsTable);
    $scope.$watch("filterState.endDate", $scope.sortReviewsTable);

    $scope.updateSearchFilter = function (filterText) {
      //Get field
      filterText.length > 0 ? searchParams.searchText = filterText : delete searchParams.searchText;
      searchParams.offsetOpt = 0;
      refreshReviews()
    };

    $scope.getExportLink = () => {
      let params = {
        reportRange: $scope.filterState.reportRange.id,
        startDate: $scope.filterState.reportRange.id === 'SpecificDates' && $scope.filterState.startDate ? $scope.filterState.startDate : null,
        endDate: $scope.filterState.reportRange.id === 'SpecificDates' && $scope.filterState.endDate ? $scope.filterState.endDate : null,
        groupId: $scope.shouldIncludeGroupId() ? $scope.groupId : undefined
      }
      return `/v5/reviewBuilder/campaign/${$scope.campaignId}/generatedReview/export?` + qs.stringify(params)
    }


    $scope.exportReviews = function() {
      let params = {
        reportRange: $scope.filterState.reportRange.id,
        startDate: $scope.filterState.reportRange.id === 'SpecificDates' && $scope.filterState.startDate ? $scope.filterState.startDate : null,
        endDate: $scope.filterState.reportRange.id === 'SpecificDates' && $scope.filterState.endDate ? $scope.filterState.endDate : null
      }
      if ($scope.shouldIncludeGroupId()) {
        params.groupId = $scope.groupId
      }
      presignedExport.downloadExport(`/v5/reviewBuilder/campaign/${$scope.campaignId}/generatedReview/export`, params)
    }

    if(reactContainer) {
      reactContainer.getContainer().setDownloadCallback(() => $scope.exportReviews);
    }

    let refreshReviewResponseTemplates = () => {
      reviewResponseTemplateService.listTemplates().then((templates) => {
        $scope.reviewResponseTemplates = templates
      })
    }
    refreshReviewResponseTemplates()

    $scope.openManageResponseTemplatesModal = () => {
      const modal = $uibModal.open({
        template: require('../../reviews/responseTemplates/templatesList.html'),
        controller: 'ReviewResponseTemplateCtrl',
        size: 'lg'
      })
      modal.closed.then(function() {
        refreshReviewResponseTemplates()
      })
    }

    function updateReviewsTable(response) {
      var reviewsList = response.data.reviews;

      _.each(reviewsList, function (item) {
        var revDetailObj = _.find(item.reviewData, function (resp) {
          return resp.name === "reviewDetail"
        });
        if (revDetailObj) {
          item.reviewDetail = revDetailObj.value;
        }
        var ratingObj = _.find(item.reviewData, function (resp) {
          return resp.name === "rating"
        });
        if (ratingObj) {
          item.rating = parseInt(ratingObj.value);
        }
        _.each(item.reviewData, function (item) {
          item.label = item.name.replace(/([a-z])([A-Z])/, "$1 $2");
        })
      });
      $scope.reviewsPaged.reviews = _.union($scope.reviewsPaged.reviews, response.data.reviews);
      $scope.reviewsPaged.total = response.data.count;
      $scope.hasMore = ($scope.reviewsPaged.currentPageNum) * $scope.reviewsPaged.pageSize < response.data.count;
      $scope.reviews = $scope.reviewsPaged.reviews;
      $scope.reviews.forEach(review => {
        // review.canRespond - Can a user respond to this review (used in child controllers)
        review.canRespond = reviewResponseConfiguration.isResponseAllowed(review)
      })

      if ($scope.updateConfig.entityId) {
        if (_.where($scope.reviewsPaged.pagedItems[0], {id: $scope.updateConfig.entityId}).length > 0) {
          $scope.updateConfig.pageOneResult = true;
        }
      }

      var accountIdToPass = $scope.accountConfig.accountId === "all" ? undefined : $scope.accountConfig.accountId;

      locationService.getLocationsInGroup($scope.groupId).then(
        locationMap => {
          $scope.locationSummaries = _.mapObject(locationMap, location => {
            const clientLocationId = !!location.locationIdForDisplay ? location.locationIdForDisplay : !!location.resellerLocId && location.resellerLocId;
            return locationService.formatLocation(location).summary + (!!clientLocationId && clientLocationId !== "" && !$scope.brandConfig.restrictions.hideClientLocationId ? ` (${clientLocationId})` : "")
          })

        }
      )

      $scope.showingMultipleLocations = () => (map($scope.locationSummaries,(key,val) => (val)).length > 1)

      $scope.reviewExportConfig = {
        export: function () {
          return reviewGenService.exportReviews(accountIdToPass);
        },
        accountId: accountIdToPass
      };

      $scope.exportLink = $scope.getExportLink()

      $scope.initialLoad = false;
      $scope.noteSettings.ready += 1;
      $scope.state = states.success;
      $scope.loadingReviewDetails = false;
    }

    setGroupId()

    $scope.loadMoreResults = function() {
      if ($scope.loadingResults || $scope.loadingReviewDetails || $scope.hasMore === false) {
        return;
      }

      $scope.reviewsPaged.currentPageNum = $scope.reviewsPaged.currentPageNum + 1
      refreshReviews(true)
    };

    $scope.findReviewType = function (review) {
      return _.findWhere($scope.reviewTypes, {id: review.reviewType});
    };

    $scope.isLocationAdminReview = function (review) {
      return $scope.findReviewType(review).canAccessAllLocations;
    };

    $scope.isGroupAdminReview = function (review) {
      return $scope.findReviewType(review).canAccessAllGroups;
    };

    $scope.openConfirmDeleteReviewModal = function (review) {
      $scope.review = angular.copy(review);
      $('#confirmDeleteReviewModal').modal();
    };

    $scope.openReviewDetailModal = function (review) {
      reviewDetailModal.open(review);
    };

    $scope.shouldIncludeGroupId = () => {
      return shouldIncludeGroupId()
    }

    function shouldIncludeGroupId() {
      return $scope.groupId.search(/^all-/) === -1
    }

    function refreshReviews(appendReviews) {
      $scope.state = states.updating;
      $scope.loadingReviewDetails = true;
      if (appendReviews !== true) {
        $scope.reviewsPaged.reviews = []
        $scope.reviewsPaged.currentPageNum = 1
      }

      let params = {
        ...searchParams,
        limitOpt: $scope.reviewsPaged.pageSize,
        cursorOpt: ($scope.reviewsPaged.currentPageNum - 1) * $scope.reviewsPaged.pageSize,
      }

      if (shouldIncludeGroupId()) {
        params.groupId = $scope.groupId
      }

      reviewGenService.searchReviewsInAdaptedFormat(params).then(function (response) {
        $scope.state = states.success;
        $scope.loadingReviewDetails = false;

        updateReviewsTable(response)
        return response;
      })

    }

    $scope.refreshReviews = () => {
      refreshReviews()
    };

    $scope.updatePagingState = function () {
      $scope.refreshReviews();
    };

    $scope.updateReview = function (review) {
      reviewGenService.updateReview(review).then(function () {
        $scope.refreshReviews();
      });
    };

    $scope.isUpdatedItemRow = function (id, entityId) {
      return id === entityId;
    };

    $scope.refreshReviews();


  })
}
